module.exports = __webpack_public_path__ + "img/error-lost-in-space.png";